<template>
  <div>

   <hr />

    <el-alert
        title="Under Development"
        type="warning"
        show-icon>
    </el-alert>

     <backhaul :rowData="rowData" />

     <insurance :rowData="rowData" />

     <permits :rowData="rowData" />

     <!-- NOT <progress>: that's a reserved native HTML element, so Vue renders the
          browser's <progress> bar instead of this component (an old, stuck spinner).
          Use a non-reserved tag so the Progress calendar table actually renders. -->
     <calendar-progress :rowData="rowData" />

     <requests :rowData="rowData" />

     <tenancy :rowData="rowData" />

  </div>
</template>


<script>

import Backhaul from '@/components/sites/calendar/Backhaul'
import Insurance from '@/components/sites/calendar/Insurance'
import Permits from '@/components/sites/calendar/Permits'
import Progress from '@/components/sites/calendar/Progress'
import Requests from '@/components/sites/calendar/Requests'
import Tenancy from '@/components/sites/calendar/Tenancy'


export default {

  components: {
    Backhaul,
    Insurance,
    Permits,
    // Registered as CalendarProgress (used as <calendar-progress>) because the
    // kebab tag <progress> collides with the reserved native HTML element.
    CalendarProgress: Progress,
    Requests,
    Tenancy,
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
}

</script>
